const STORAGE_KEY = 'xuxuai_pending_tasks';

export interface PendingTask {
  taskId: string;
  action: string;
  createdAt: number;
}

export function savePendingTask(taskId: string, action: string) {
  try {
    const tasks = getPendingTasks();
    if (!tasks.find((t) => t.taskId === taskId)) {
      tasks.push({ taskId, action, createdAt: Date.now() });
      localStorage.setItem(STORAGE_KEY, JSON.stringify(tasks));
    }
  } catch {}
}

export function getPendingTasks(): PendingTask[] {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const tasks: PendingTask[] = JSON.parse(raw);
    const oneHour = 60 * 60 * 1000;
    return tasks.filter((t) => Date.now() - t.createdAt < oneHour);
  } catch {
    return [];
  }
}

export function removePendingTask(taskId: string) {
  try {
    const tasks = getPendingTasks().filter((t) => t.taskId !== taskId);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(tasks));
  } catch {}
}
